import {Vuex} from 'ui.vue.vuex';

import simple from "./Simple";
import login from "./Login";

let store = Vuex.store({
    modules: {
        bxmaker: {
            namespaced: true,
            state: {},
            modules: {
                authuseremail: {
                    namespaced: true,
                    state: {
                        a:1,
                    },
                    modules: {
                        simple,
                        login
                    }
                }
            }
        }
    //     'bxmaker.authuserphone.login': login,
    }
});



export default store;
